import React, {Component} from 'react';
import {Container, Typography} from '@material-ui/core'
import CasesTable from "./CasesTable";
import CasesMap from "./CasesMap";
import CasesChart from "./CasesChart";
import firebase from 'firebase/app';
import 'firebase/database'
import CurveChart from "./CurveChart";
import CanadaOverview from "./CanadaOverview";
import ProvinceWithMostCases from "./ProvinceWithMostCases";

class BodyContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            table_data: [],
            curve_data: [],
            width: window.innerWidth,
            height: window.innerHeight,
            updated_time: null
        }
    }

    /* -------- LIFECYCLE METHODS -------- */
    componentDidMount() {
        window.addEventListener('resize', this.updateDimensions);
        let database = firebase.database();
        let table_data = []
        let curve_data = []
        let query = database.ref("cases").orderByKey();
        const that = this;
        query.once("value")
            .then(function(snapshot) {

                let currentCases = snapshot.child("current")
                let updated_time = snapshot.child("update_time/value").val()
                let curveData = snapshot.child('daily')

                currentCases.forEach(function(childSnapshot) {
                    table_data.push(childSnapshot.val());
                });

                curveData.forEach(function(childSnapshot) {
                    curve_data.push(childSnapshot.val());
                });

                that.setState({
                    table_data,
                    updated_time,
                    curve_data
                })
            });
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
    }

    updateDimensions = () => {
        this.setState({
            width: window.innerWidth,
            height: window.innerHeight
        });
    };

    /* -------- FUNCTIONS -------- */


    /* -------- API CALLS -------- */


    /* -------- RENDERS -------- */
    render() {

        return <Container>
            <Typography variant={this.state.width <= 856 ? "h4" : "h2"}>Canada COVID-19 Tracker</Typography>
            <CanadaOverview data={this.state.table_data} dimensions={[this.state.width, this.state.height]}/>
            <CasesChart data={this.state.table_data} dimensions={[this.state.width, this.state.height]}/>
            <CasesMap data={this.state.table_data} dimensions={[this.state.width, this.state.height]}/>
            <CurveChart data={this.state.curve_data} dimensions={[this.state.width, this.state.height]}/>
            <ProvinceWithMostCases data={this.state.curve_data} dimensions={[this.state.width, this.state.height]}/>
            <CasesTable data={this.state.table_data} dimensions={[this.state.width, this.state.height]}/>
            <div style={{
                position: 'fixed',
                bottom: 28,
                right: 8,
                backgroundColor: '#fff',
                paddingRight: 8,
                paddingLeft: 8,
                boxShadow: 'rgba(0, 0, 0, 0.3) 0px 1px 3px',
                width: 256,
                display: 'flex',
                flexDirection: 'column',
                borderRadius: 4}}>
                <Typography variant={'caption'}>Since so many other awesome trackers are available now, I'm retiring this site. It was a great journey, and I hope for this pandemic to be over soon.</Typography>
                <Typography variant={'caption'}>Last Updated: May 03, 2020: 04:39pm EDT</Typography>
            </div>
        </Container>
    }
}

export default BodyContainer